export const guideModules: any = {
  claims: {
    endpoint: '/claim/import',
    exampleFile:
      'https://figalaxy.s3.us-west-1.amazonaws.com/import-examples/importing-claims.csv',
    guides: {
      title:
        'To import claim, you must create an Excel sheet that contains optional and required columns, Use this file(example file) to importing the claims and you can add and update data on this file',
      content: [
        'Contract number: Mandatory and numbers from contract number represent contract ID from contracts, also you can use export function from contract list from the system and get the contracts code from this sheet ex: 28001527',
        'Claim prefix code: Mandatory and varchar from title of claim prefix from claim settings ex: Demo.',
        'Claim adjustor email: Mandatory from the staff/ users from my account ex: dev@creatifyteam.com',
        'Product code: Mandatory and varchar, the product code is existing at product list from the system ex: 1-distinctioO',
        'Customer name: Mandatory and varchar, the customer’s name is existing at third party list from the system also you can use export function from third parties list from the system and get the customer’s name from this sheet ex: John Edison',
        'Customer Email: Mandatory and varchar, the customer’s email is existing at third party list from the system also you can use export function from third parties list from the system and get the customer’s email from this sheet ex: john@example.com',
        'Customer Address: Mandatory and varchar, the customer’s address is existing at third party list from the system also you can use export function from third parties list from the system and get the customer address from this sheet ex: 4505 Morar Forks Terry Chester, MN 12213',
        'Customer country: Mandatory and text, the customer’s country is existing at third party list from the system also you can use export function from third parties list from the system and get the customer country from this sheet ex: United States',
        'Customer state: Mandatory and Text, the customer’s state is existing at third party list from the system also you can use export function from third parties list from the system and get the customer state from this sheet ex: MN',
        'Customer city: Mandatory and Text, the customer’s city is existing at third party list from the system also you can use export function from third parties list from the system and get the customer city from this sheet ex: Morar Forks',
        'Customer zip code: Mandatory and numeric, the customer’s zip code is existing at third party list from the system also you can use export function from third parties list from the system and get the customer ZIP code from this sheet ex: 123',
        'Customer phone number: Mandatory and numeric, the customer’s phone number is existing at third party list from the system also you can use export function from third parties list from the system and get the customer phone number from this sheet ex: 11234567890',
        'Repair facility code: Mandatoy and varchar, third parties code of type repair facilities separated by comma also you can use export function from third parties list from the system and get the third-party code from this sheet ex: REPFAC-00029, REPFAC-00028, REPFAC-00027',
        'Service advisor code: Mandatory and varchar, third parties code of type service advisor separated by comma ex: SERADV-00027, SERADV-00026, SERADV-00025',
        'Claim date: Mandatory and date ex: 1/31/2024',
        'Is towed: Mandatory and Boolean (0,1)',
        'Is occurred before: Mandatory and Boolean (0,1)',
        'Claim mileage: Mandatory and numeric ex: 9800',
        'Amount: Mandatory and numeric ex: 500',
        'Description: Optional and text',
        'Status: Mandatory and text ex: open, paid, denied, expired, authorized, suspended, rejected, inspector-rejected, manager-override, request-inspector, request-insurer-review',
        'Claim deductible: Mandatory and numeric ex: 12',
      ],
    },
  },
  products: {
    endpoint: '/product/import',
    exampleFile:
      'https://figalaxy.s3.us-west-1.amazonaws.com/import-examples/importing-products.csv',
    guides: {
      title:
        'To import products, you must create an Excel sheet that contains optional and required columns,  Use this file(example file) to importing the products and you can add and update data on this file',
      content: [
        'Code: varchar, Mandatory and Unique => P005.',
        'Product Name: varchar, Mandatory and Unique.',
        'Description: text, Optional.',
        'Product Type:  Text, Mandatory => tire & wheel.',
        'Third-party code is producer code: varchar and mandatory, to get the producer code redirect to third-party list and copy a producer code from the system also you can use export function from third parties list from the system and get the third-party code from this sheet ex: 00002.',
        'milestones: optional, Text ;  milestone and description added to the product separated by comma and can add many of milestones to the product separated by semicolon ex :name1,description1;name2,description2.',
        'Tag or Category: text, Mandatory, ex: Customer',
        'Duration: number, optional ex: 65.',
      ],
    },
  },
  contracts: {
    endpoint: '/contracts/import-contracts-report-43',
    exampleFile: './assets/file/new-contract-importer-template.csv',
    guides: {
      title:
        'To import contracts, you must create an Excel sheet that contains optional and required columns. Use the provided example file to import contracts. You can add and update data using this file.',
      content: [
        'Type: Type of row, Varchar, Mandatory, example: CONTRACT',
        'Seller#: Varchar, Mandatory',
        'Seller Name: Varchar, Mandatory',
        'Seller Phone Number: Number, Optional',
        'Seller Address 1: Varchar, Mandatory',
        'Seller Address 2: Varchar, Optional',
        'Seller City: Varchar, Mandatory',
        'Seller State: Varchar, Mandatory',
        'Seller ZIP: Number, Mandatory',
        'Agent #: Varchar, Mandatory',
        'Agent Name: Varchar, Mandatory',
        'Insurance Carrier: Varchar, Mandatory',
        'Contract Type: Varchar, Mandatory',
        'Program: Varchar, Mandatory',
        'Option Name: Varchar, Optional',
        'New/Used: Varchar, Mandatory, "N" for New, "U" for Used',
        'Plan Code: Varchar, Mandatory',
        'Plan Name: Varchar, Mandatory',
        'Term Months: Number, Mandatory',
        'Term Miles: Number, Mandatory',
        'Deductible: Number, Mandatory, default 0 if not provided',
        'Deductible Type: Varchar, Mandatory',
        'Expiration Date: Date, Mandatory, example: 8/27/2028',
        'Expiration Mileage: Number, Mandatory',
        'VIN: Varchar, Mandatory, example: 1gkb2gkc0hr323633',
        'Vehicle Year: Number, Mandatory',
        'Make: Varchar, Mandatory',
        'Model: Varchar, Mandatory',
        'Vehicle Class: Number, Mandatory',
        'In Service Date: Date, Optional',
        'Contract ID: Number, Mandatory',
        'Contract #: Number, Mandatory',
        'Sale Date: Date, Mandatory',
        'Sale Odometer: Number, Mandatory',
        'Cancellation Effective Date: Date, Optional',
        'Cancellation Mileage: Number, Optional',
        'Cancellation Factor: Number, Mandatory, default 0 if not provided',
        'Cancellation Fee: Number, Mandatory, default 0 if not provided',
        'Posted Date: Date, Mandatory, example: 1/30/2023 12:53:28 PM',
        'Transaction Type: Varchar, Mandatory',
        'First Name: Varchar, Mandatory',
        'Last Name: Varchar, Mandatory',
        'Customer Spouse: Varchar, Optional',
        'Customer Address 1: Varchar, Mandatory',
        'Customer Address 2: Varchar, Optional',
        'Customer City: Varchar, Mandatory',
        'Customer State: Varchar, Mandatory',
        'Customer Zip Code: Number, Mandatory',
        'Customer Evening Phone: Number, Mandatory, default 0 if not provided',
        'Customer Day Phone: Number, Mandatory, default 0 if not provided',
        'Customer Email: Number, Mandatory',
        'Retail Cost: Amount in $, Mandatory',
        'Retail Tax 1: Amount in $, Mandatory',
        'Retail Tax 2: Amount in $, Mandatory',
        'NET Cost: Amount in $, Mandatory',
        'NET Tax 1: Amount in $, Mandatory',
        'NET Tax 2: Amount in $, Mandatory',
        'Admin 1 → Admin 10: Amount in $, Mandatory, use 0 if not applicable',
        'Premium 1 → Premium 4: Amount in $, Mandatory, use 0 if not applicable',
        'Commission 1 → Commission 5: Amount in $, Mandatory, use 0 if not applicable',
        'Deal Type: Varchar, Mandatory',
        'Limit of Liability: Percentage %, Mandatory',
        'Financed Amount: Amount in $, Mandatory',
        'APR: Percentage %, Mandatory',
        'Finance Term: Number, Mandatory',
        'MSRP: Amount in $, Mandatory',
        'Balloon Amount: Amount in $, Mandatory',
        'Residual Amount: Amount in $, Mandatory',
        'Base ACV: Amount in $, Mandatory',
        'NADA Value: Amount in $, Mandatory',
        'Monthly Payment: Amount in $, Mandatory',
        'First Payment Date: Date, Optional',
        'Carrier Account #: Optional',
        'Member ID: Optional',
        'Lien Holder Number: Optional',
        'Lien Holder Name: Optional',
        'Lien Holder Address 1: Optional',
        'Lien Holder Address 2: Optional',
        'Lien Holder City: Optional',
        'Lien Holder State: Optional',
        'Lien Holder Zip Code: Optional',
        'Insured State: Varchar, Mandatory',
        'Program ID: Number, Mandatory',
        'Process Code: Number, Mandatory',
        'Seller Type: Varchar, Optional',
        'Management Co. #: Number, Optional',
        'Management Co. Name: Varchar, Optional',
        'Rate Book: Number, Mandatory',
        'No Charge Back: Number, Mandatory, default 0 if not provided',
        'Reinsurance Treaty Name: Varchar, Mandatory',
        'Current Reinsurance Treaty: Varchar, Mandatory',
      ],
    },
  },
  dealers: {
    endpoint: '/import-dealers',
    exampleFile:
      'https://figalaxy.s3.us-west-1.amazonaws.com/import-examples/importing-dealers.csv',
    guides: {
      title:
        'To import dealers, you must create an Excel sheet that contains optional and required columns,  Use this file(example file) to importing the dealers and you can add and update data on this file',
      content: [
        'Dealer ID: required | unique for dealers',
        'Owner First Name: optional',
        'Owner Last Name: optional',
        'Dealership Name: required',
        'Address: optional',
        'City: optional',
        'State: optional',
        'Zip: optional',
        'Phone Number: optional',
        'Agency Assigned Id Number: optional | exists in agency',
      ],
    },
  },
  'fortegra-claims': {
    endpoint: '/claim/import-fortegra-claims',
    exampleFile: './assets/file/import-fortegra-claims-template.csv',
    guides: {
      title:
        'To import Fortegra claims, you must create an Excel sheet that contains the required columns in exact order. Use this file (example file) to import Fortegra claims.',
      content: [
        'CONTRACT NUMBER: Mandatory, must exist in the system',
        'Claim#: Mandatory, claim number',
        'Paid Date: Mandatory, date format ex: 1/31/2024',
        'PLAN DESCRIPTION: Optional, plan description text',
        'DEALERSHIP: Optional, dealership name',
        'STATE: Optional, state abbreviation',
        'Parts: Optional, numeric amount',
        'Labor: Optional, numeric amount',
        'Sublet: Optional, numeric amount',
        'Other: Optional, numeric amount',
        'Deductible: Optional, numeric amount',
        'Import Reference: Mandatory, unique reference identifier',
        'Taxes: Optional, numeric amount',
        'Total Paid: Mandatory, numeric amount',
        'Amount Mode: Optional, set or add — overrides the page selection for that row',
        'Pay Method: Optional, payment method',
        'Check / ACH #: Optional, check or ACH number',
        'Payee Name and Address: Mandatory, payee information',
        'Amount Mode (set): replaces the claim\'s Paid Amount with the imported Paid Amount',
        'Amount Mode (add): adds the imported Paid Amount on top of the claim\'s current Paid Amount',
        'Amount Mode (fallback): if left empty, the Amount Mode selected on the Import page is used',
      ],
    },
  },
  'fortegra-repair-facilities': {
    endpoint: '/third-parties/import-fortegra-repair-facilities',
    exampleFile: './assets/file/import-fortegra-repair-facilities-template.csv',
    guides: {
      title:
        'To import Fortegra Repair Facilities, create a file with a single field containing the payee name and address information in the specific format shown below.',
      content: [
        'Field Name:',
        'Payee Name and Address',
        'Format (one line only):',
        'Name StreetAddress City State ZIP',
        'Examples:',
        'John Doe 123 Main Street Boston MA 02101',
        'Jane Smith 456 Oak Avenue Springfield IL 62701',
        'ABC Company 789 Park Boulevard Los Angeles CA 90001',
        'Robert Lee 100 Elm Road Miami FL 33101',
        'Tech Corp 999 Innovation Drive Austin TX 78701',
        'Mary Williams 25 Cedar Lane Chicago IL 60601',
        'Dr. Sarah Johnson 1500 Medical Center Parkway San Francisco CA 94102',
        'Key Points:',
        '• Full name or company name',
        '• Street address with number',
        '• City name',
        '• Two-letter state code',
        '• Five-digit ZIP code',
        '• Everything must be on one line, separated by spaces',
        'Quick Tips:',
        '• Must end with: STATE ZIP (e.g. MA 02101)',
        '• State must be exactly 2 letters',
        '• ZIP must be 5 digits',
        '• Do not use ZIP+4 format (e.g. 02101-1234)',
        '• Do not use state abbreviations longer or shorter than 2 letters',
      ],
    },
  },
  'accounting-transactions': {
    endpoint: '/contracts/transactions/import-contracts-transactions',
    exampleFile: './assets/file/import-accounting-transactions-template.csv',
    guides: {
      title:
        'To import accounting transactions, you must create a CSV file that contains all required columns. Use the template file to import transactions.',
      content: [
        'ContractNumber: Required – must exist in contracts table',
        'ChargebackType: Required – one of: Chargeback (default), No From Reserve, No From RP, No From Commission, No Chargeback',
        'CreateDate: Optional – date/time format (Y-m-d or Y-m-d H:i:s)',
        'AllocationPriority: Optional',
        'ClaimNumber: Optional – if provided, must exist in claims table',
        'Amount: Optional (required for non-chargeback transactions)',
        'Description: Optional – transaction description',
        'TransactionDate: Required – date/time format (Y-m-d or Y-m-d H:i:s)',
        'ChargebackAmount: Optional (required if transaction is chargeback)',
        'ContractCommissionId: Optional',
        'DescriptorName: Optional',
        'TransactionDirection: Required',
        'ChargebackDate: Optional – date format (Y-m-d)',
        'ExternalId: Optional',
        'TransactionType: Required – one of: Commission, Reserve, Funding, Reserve Expense, Claim',
        'ChargebackTrigger: Optional – used in Cancel, Refund',
        'ContractTransactionId: Required',
        'InternalCode: Required – for third-party lookup',
        'PaymentSource: Required',
        'BatchNumber: Optional – batch identifier for grouping transactions',
        'Summary of Mandatory Fields:',
        '• ContractNumber, TransactionDate, TransactionType, ContractTransactionId, PaymentSource, InternalCode, ChargebackType, TransactionDirection',
        'Validation Notes:',
        '• ContractNumber must exist in the contracts table',
        '• ClaimNumber (if provided) must exist in the claims table',
        '• Date Format: Y-m-d or Y-m-d H:i:s (examples: 2024-01-31 or 2024-01-31 14:30:00)',
        '• ChargebackDate Format: Y-m-d (example: 2024-01-31)',
      ],
    },
  },
};
